import axios from "axios";
import { useEffect } from "react";
import { useContext, useState } from "react";
import { Container, Form, Row, Col, Button } from "react-bootstrap";
import { DatePicker } from "zaman";
import { MyContext } from "../helper/MyContext";

const FormData = require('form-data');


export function StepTwo(props) {
    const url = 'https://khpc.ir/sup-upload/';
    const [catalogs, setCatalogs] = useState('');
    const [nationalCard, setNationalCard] = useState('');
    const [license, setLicense] = useState('');

    const [datesLicense, setDatesLicense] = useState({
        startDateBusinessLicense: '',
        endDateBusinessLicense: '',
        unlimitedDateBusinessLicense: false,
        ///
        startDateEconomyCode: '',
        endDateEconomyCode: '',
        unlimitedDateEconomyCode: '',
        ///
        startDateQualityManagementCertificate: '',
        endDateQualityManagementCertificate: '',
        unlimitedDateQualityManagementCertificate: false,
        ///
        startDateHse: '',
        endDateHse: '',
        unlimitedDateHse: false,
        ///
        startEnvironmentCertificate: '',
        endEnvironmentCertificate: '',
        unlimitedEnvironmentCertificate: false,
        ///
        startDateEnergyCertificate: '',
        endDateEnergyCertificate: '',
        unlimitedDateEnergyCertificate: false,
        ///
        startDateProductStandard: '',
        endDateProductStandard: '',
        unlimitedDateProductStandard: false,
        ///
        startDateIranCode: '',
        endDateIranCode: '',
        unlimitedIranCode: false,
        ///
        startDateWarranty: '',
        endDateWarranty: '',
        unlimitedDateWarranty: false,
        ///
        startDateGarranty: '',
        endDateGarranty: '',
        unlimitedDateGarranty: false,
        ///
        startDateVendorList: '',
        endDateVendorList: '',
        unlimitedDateVendorList: false,
    })


    const [economyCode, setEconomyCodeLicense] = useState('');

    const [qOne, setQOne] = useState('');
    const [qTwo, setQTwo] = useState('');
    const [qThree, setQThree] = useState('');
    const [qFour, setQFour] = useState('');
    const [qFive, setQFive] = useState('');
    const [qSix, setQSix] = useState('');
    const [qSeven, setQSeven] = useState('');
    const [qEight, setQEight] = useState('');
    const [qNine, setQNine] = useState('');
    const [qTen, setQTen] = useState('');

    const [aOne, setAOne] = useState('');
    const [aTwo, setATwo] = useState('');
    const [aThree, setAThree] = useState('');
    const [aFour, setAFour] = useState('');
    const [aFive, setAFive] = useState('');
    const [aSix, setASix] = useState('');
    const [aSeven, setASeven] = useState('');
    const [aEight, setAEight] = useState('');
    const [aNine, setANine] = useState('');
    const [aTen, setATen] = useState('');

    const [startOne, setStartOne] = useState(false);
    const [startTwo, setStartTwo] = useState(false);
    const [startThree, setStartThree] = useState(false);
    const [startFour, setStartFour] = useState(false);

    const [startQOne, setStartQOne] = useState(false);
    const [startQTwo, setStartQTwo] = useState(false);
    const [startQThree, setStartQThree] = useState(false);
    const [startQFour, setStartQFour] = useState(false);
    const [startQFive, setStartQFive] = useState(false);
    const [startQSix, setStartQSix] = useState(false);
    const [startQSeven, setStartQSeven] = useState(false);
    const [startQEight, setStartQEight] = useState(false);
    const [startQNine, setStartQNine] = useState(false);
    const [startQTen, setStartQTen] = useState(false);

    const [firstData, setFirstData] = useState(true);

    const { user } = useContext(MyContext);

    const [data, setData] = useState({
        statute: '',
        founded: '',
        nationalIDCertificate: '',
        certificateOfAddedValue: '',
        economicCodeCertificate: '',
        certificateOfChange: ''
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        let Mount = true;
        if (Mount) {
            let datao = new FormData();
            datao.append('userId', user);
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://khpc.ir/api-supplier/api/getRequestByUserId',
                data: datao
            };

            axios.request(config)
                .then((response) => {
                    var dataLoaded = JSON.parse(response.data.data.dataTwo);
                    if (dataLoaded) {
                        setCatalogs(dataLoaded.catalogs);
                        setNationalCard(dataLoaded.nationalCard);
                        setLicense(dataLoaded.license);
                        setEconomyCodeLicense(dataLoaded.economyCode);
                        setDatesLicense(dataLoaded.datesLicense);
                        setData(prevState => (
                            {
                                ...prevState,
                                nationalIDCertificate: dataLoaded.nationalIDCertificate,
                                statute: dataLoaded.statute,
                                founded: dataLoaded.founded,
                                certificateOfAddedValue: dataLoaded.certificateOfAddedValue,
                                economicCodeCertificate: dataLoaded.economicCodeCertificate,
                                certificateOfChange: dataLoaded.certificateOfChange
                            }))

                        if (dataLoaded.aOne) {
                            setQOne(true);
                            setAOne(dataLoaded.aOne);
                        }
                        if (dataLoaded.aTwo) {
                            setQTwo(true);
                            setATwo(dataLoaded.aTwo);
                        }
                        if (dataLoaded.aThree) {
                            setQThree(true);
                            setAThree(dataLoaded.aThree);
                        }
                        if (dataLoaded.aFour) {
                            setQFour(true);
                            setAFour(dataLoaded.aFour);
                        }
                        if (dataLoaded.aFive) {
                            setQFive(true);
                            setAFive(dataLoaded.aFive);
                        }
                        if (dataLoaded.aSix) {
                            setQSix(true);
                            setASix(dataLoaded.aSix);
                        }
                        if (dataLoaded.aSeven) {
                            setQSeven(true);
                            setASeven(dataLoaded.aSeven);
                        }
                        if (dataLoaded.aEight) {
                            setQEight(true);
                            setAEight(dataLoaded.aEight);
                        }
                        if (dataLoaded.aNine) {
                            setQNine(true);
                            setANine(dataLoaded.aNine);
                        }
                        if (dataLoaded.aTen) {
                            setQTen(true);
                            setATen(dataLoaded.aTen);
                        }
                    }

                    setFirstData(false)
                })
                .catch((error) => {
                    setFirstData(false)
                    // alert('تامین کننده گرامی، درخواست شما با خطا مواجه شد لطفا با پشتیبانی تماس بگیرید');
                });
        }
        return () => Mount = false;
    }, []);

    const Upload = async (event) => {
        if (event.target.files[0]?.type !== 'application/x-zip-compressed' && event.target.files[0]?.type !== 'application/zip') {
            alert('پسوند فایل بایستی zip باشد');
            return;
        }
        setStartOne(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setCatalogs(res.data.name)
                setStartOne(false)

            })
            .catch(err => {
                console.log(err)
                setStartOne(false)
            })
    }

    const UploadNationalCard = async (event) => {
        if (event.target.files[0]?.type !== 'image/jpeg') {
            alert('پسوند فایل بایستی jpg باشد');
            return;
        }
        setStartTwo(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setNationalCard(res.data.name)
                setStartTwo(false)

            })
            .catch(err => {
                console.log(err)
                setStartTwo(false)
            })
    }

    const UploadLicense = async (event) => {
        if (event.target.files[0]?.type !== 'image/jpeg') {
            alert('پسوند فایل بایستی jpg باشد');
            return;
        }
        setStartThree(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setLicense(res.data.name)
                setStartThree(false)

            })
            .catch(err => {
                console.log(err)
                setStartThree(false)
            })
    }

    const UploadEconomyCode = async (event) => {
        if (event.target.files[0]?.type !== 'application/pdf') {
            alert('پسوند فایل بایستی pdf باشد');
            return;
        }
        setStartFour(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setEconomyCodeLicense(res.data.name)
                setStartFour(false)

            })
            .catch(err => {
                console.log(err)
                setStartFour(false)
            })
    }

    const UploadAOne = async (event) => {
        if (event.target.files[0]?.type !== 'application/pdf') {
            alert('پسوند فایل بایستی pdf باشد');
            return;
        }
        setStartQOne(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setAOne(res.data.name)
                setStartQOne(false)

            })
            .catch(err => {
                console.log(err)
                setStartQOne(false)
            })
    }

    const UploadATwo = async (event) => {
        if (event.target.files[0]?.type !== 'application/pdf') {
            alert('پسوند فایل بایستی pdf باشد');
            return;
        }
        setStartQTwo(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setATwo(res.data.name)
                setStartQTwo(false)

            })
            .catch(err => {
                console.log(err)
                setStartQTwo(false)
            })
    }

    const UploadAThree = async (event) => {
        if (event.target.files[0]?.type !== 'application/pdf') {
            alert('پسوند فایل بایستی pdf باشد');
            return;
        }
        setStartQThree(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setAThree(res.data.name)
                setStartQThree(false)

            })
            .catch(err => {
                console.log(err)
                setStartQThree(false)
            })
    }

    const UploadAFour = async (event) => {
        if (event.target.files[0]?.type !== 'application/pdf') {
            alert('پسوند فایل بایستی pdf باشد');
            return;
        }
        setStartQFour(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setAFour(res.data.name)
                setStartQFour(false)

            })
            .catch(err => {
                console.log(err)
                setStartQFour(false)
            })
    }

    const UploadAFive = async (event) => {
        if (event.target.files[0]?.type !== 'application/pdf') {
            alert('پسوند فایل بایستی pdf باشد');
            return;
        }
        setStartQFive(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setAFive(res.data.name)
                setStartQFive(false)

            })
            .catch(err => {
                console.log(err)
                setStartQFive(false)
            })
    }

    const UploadASix = async (event) => {
        if (event.target.files[0]?.type !== 'application/pdf') {
            alert('پسوند فایل بایستی pdf باشد');
            return;
        }
        setStartQSix(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setASix(res.data.name)
                setStartQSix(false)

            })
            .catch(err => {
                console.log(err)
                setStartQSix(false)
            })
    }

    const UploadASeven = async (event) => {
        if (event.target.files[0]?.type !== 'application/pdf') {
            alert('پسوند فایل بایستی pdf باشد');
            return;
        }
        setStartQSeven(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setASeven(res.data.name)
                setStartQSeven(false)

            })
            .catch(err => {
                console.log(err)
                setStartQSeven(false)
            })
    }

    const UploadAEight = async (event) => {
        if (event.target.files[0]?.type !== 'application/pdf') {
            alert('پسوند فایل بایستی pdf باشد');
            return;
        }
        setStartQEight(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setAEight(res.data.name)
                setStartQEight(false)

            })
            .catch(err => {
                console.log(err)
                setStartQEight(false)
            })
    }

    const UploadANine = async (event) => {
        if (event.target.files[0]?.type !== 'application/pdf') {
            alert('پسوند فایل بایستی pdf باشد');
            return;
        }
        setStartQNine(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setANine(res.data.name)
                setStartQNine(false)

            })
            .catch(err => {
                console.log(err)
                setStartQNine(false)
            })
    }

    const UploadATen = async (event) => {
        if (event.target.files[0]?.type !== 'application/pdf') {
            alert('پسوند فایل بایستی pdf باشد');
            return;
        }
        setStartQTen(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setATen(res.data.name)
                setStartQTen(false)

            })
            .catch(err => {
                console.log(err)
                setStartQTen(false)
            })
    }

    const [submit, setSubmit] = useState(false);

    const changeStepBack = () => {

        window.scrollTo(0, 0);
        props.changeStep("1");

    }

    const changeStep = () => {
        setSubmit(true);
        if (
            props.dataOne?.type == '2' && data.statute == '' ||
            props.dataOne?.type == '2' && data.founded == '' ||
            props.dataOne?.type == '2' && data.nationalIDCertificate == '' ||
            props.dataOne?.type == '2' && data.certificateOfAddedValue == '' ||
            props.dataOne?.type == '2' && data.economicCodeCertificate == ''
        ) {
            alert('بارگذاری مدارک شرکت الزامی است');
            return;
        }

        if (props.dataOne?.type == '2' && (qOne && aOne == '') ||
            props.dataOne?.type == '2' && (qTwo && aTwo == '') ||
            props.dataOne?.type == '2' && (qThree && aThree == '') ||
            props.dataOne?.type == '2' && (qFour && aFour == '') ||
            props.dataOne?.type == '2' && (qFive && aFive == '') ||
            props.dataOne?.type == '2' && (qSix && aSix == '') ||
            props.dataOne?.type == '2' && (qSeven && aSeven == '') ||
            props.dataOne?.type == '2' && (qEight && aEight == '') ||
            props.dataOne?.type == '2' && (qNine && aNine == '') ||
            props.dataOne?.type == '2' && (qTen && aTen == '')) {
            alert('فیلدهای مشخص شده الزامی هستند');
            return;
        }


        if (
            props.dataOne?.type == '1' && nationalCard == '' ||
            props.dataOne?.type == '1' && license == '' ||
            props.dataOne?.type == '1' && (qOne && aOne == '') ||
            props.dataOne?.type == '1' && (qTwo && aTwo == '') ||
            props.dataOne?.type == '1' && (qThree && aThree == '') ||
            props.dataOne?.type == '1' && (qFour && aFour == '') ||
            props.dataOne?.type == '1' && (qFive && aFive == '') ||
            props.dataOne?.type == '1' && (qSix && aSix == '') ||
            props.dataOne?.type == '1' && (qSeven && aSeven == '') ||
            props.dataOne?.type == '1' && (qEight && aEight == '') ||
            props.dataOne?.type == '1' && (qNine && aNine == '') ||
            props.dataOne?.type == '1' && (qTen && aTen == '')
        ) {
            alert('فیلدهای مشخص شده الزامی هستند');
            return;
        }

        if (props.dataOne?.type == '1' && license && !datesLicense.unlimitedDateBusinessLicense && datesLicense.endDateBusinessLicense == '' && datesLicense.startDateBusinessLicense == '') {
            alert('ورودی تاریخ ها الزامی هستند');
            return;
        }

        if (props.dataOne?.type == '1' && economyCode && !datesLicense.unlimitedDateEconomyCode && datesLicense.endDateEconomyCode == '' && datesLicense.startDateEconomyCode == '') {
            alert('ورودی تاریخ ها الزامی هستند');
            return;
        }

        if (qOne && !datesLicense.unlimitedDateQualityManagementCertificate && datesLicense.endDateQualityManagementCertificate == '' && datesLicense.startDateQualityManagementCertificate == '') {
            alert('ورودی تاریخ ها الزامی هستند');
            return;
        }
        if (qTwo && !datesLicense.unlimitedDateHse && datesLicense.endDateHse == '' && datesLicense.startDateHse == '') {
            alert('ورودی تاریخ ها الزامی هستند');
            return;
        }
        if (qThree && !datesLicense.unlimitedEnvironmentCertificate && datesLicense.endEnvironmentCertificate == '' && datesLicense.startEnvironmentCertificate == '') {
            alert('ورودی تاریخ ها الزامی هستند');
            return;
        }

        if (qFour && !datesLicense.unlimitedDateEnergyCertificate && datesLicense.endDateEnergyCertificate == '' && datesLicense.startDateEnergyCertificate == '') {
            alert('ورودی تاریخ ها الزامی هستند');
            return;
        }

        if (qFive && !datesLicense.unlimitedDateProductStandard && datesLicense.endDateProductStandard == '' && datesLicense.startDateProductStandard == '') {
            alert('ورودی تاریخ ها الزامی هستند');
            return;
        }

        if (qSix && !datesLicense.unlimitedIranCode && datesLicense.endDateIranCode == '' && datesLicense.startDateIranCode == '') {
            alert('ورودی تاریخ ها الزامی هستند');
            return;
        }

        if (qSeven && !datesLicense.unlimitedDateGarranty && datesLicense.endDateGarranty == '' && datesLicense.startDateGarranty == '') {
            alert('ورودی تاریخ ها الزامی هستند');
            return;
        }

        if (qEight && !datesLicense.unlimitedDateWarranty && datesLicense.endDateWarranty == '' && datesLicense.startDateWarranty == '') {
            alert('ورودی تاریخ ها الزامی هستند');
            return;
        }

        if (qNine && !datesLicense.unlimitedDateVendorList && datesLicense.endDateVendorList == '' && datesLicense.startDateVendorList == '') {
            alert('ورودی تاریخ ها الزامی هستند');
            return;
        }

        window.scrollTo(0, 0);

        var dataInsert = {
            catalogs: catalogs,
            nationalCard: nationalCard,
            license: license,
            economyCode: economyCode,
            aOne: aOne,
            aTwo: aTwo,
            aThree: aThree,
            aFour: aFour,
            aFive: aFive,
            aSix: aSix,
            aSeven: aSeven,
            aEight: aEight,
            aNine: aNine,
            aTen: aTen,
            datesLicense: datesLicense,
            statute: data.statute,
            founded: data.founded,
            nationalIDCertificate: data.nationalIDCertificate,
            certificateOfAddedValue: data.certificateOfAddedValue,
            economicCodeCertificate: data.economicCodeCertificate,
            certificateOfChange: data.certificateOfChange
        };

        let dataForm = new FormData();
        dataForm.append('userId', user);
        dataForm.append('json', JSON.stringify(dataInsert));

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://khpc.ir/api-supplier/api/sendRequestStepTwo',
            data: dataForm
        };

        axios.request(config)
            .then((response) => {
                if (response.data.error) {
                    alert(response.data.message);
                } else {
                    props.setData(dataInsert);
                    props.changeStep("3");
                }
                setSubmit(false);
            })
            .catch((error) => {
                alert('تامین کننده گرامی، درخواست شما با خطا مواجه شد لطفا با پشتیبانی تماس بگیرید');
                setSubmit(false);
            });

    }

    const handleSetDate = (name, date) => {
        if (!date) return;
        var newDate = new Date(date);
        var returnDate = `${newDate.getFullYear()}/${(newDate.getMonth() + 1) < 10 ? `0` + (newDate.getMonth() + 1) : (newDate.getMonth() + 1)}/${newDate.getDate() < 10 ? `0` + newDate.getDate() : newDate.getDate()}`;
        setDatesLicense(prevState => ({ ...prevState, [name]: returnDate }))
    }

    const [uploadLoading, setUploadLoading] = useState(false);

    const UploadDoc = async (name, event) => {
        if (event.target.files[0]?.type !== 'application/pdf') {
            alert('پسوند فایل بایستی pdf باشد');
            return;
        }
        setUploadLoading(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setData(prevState => ({ ...prevState, [name]: res.data.name }));
                setUploadLoading(false);
            })
            .catch(err => {
                setUploadLoading(false)
            })
    }

    if (firstData) {
        return (
            <>
                <Container className="mt-2" >
                    <Row>
                        <Col xs="12">
                            در حال بارگزاری
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }

    return (
        <Container className="mt-2" >
            <Row>
                <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                    <label className="text-g fw-bold">اسناد و مدارک (اسناد دارای تاریخ معتبر باشند)</label>
                </Col>
                <Col xs={12} className="mt-4">
                    <Form.Group controlId="formFile1" className="mb-4">
                        <Form.Label>بروشور و مدارک فنی (فرمت zip)</Form.Label>
                        <Form.Control disabled={startOne} onChange={(e) => Upload(e)} type="file" size="sm" accept=".zip" />
                    </Form.Group>
                    {
                        catalogs &&
                        <a target="_blank" className="mb-2" href={url + catalogs} download>نمایش فایل</a>
                    }
                    <hr />
                </Col>

                {
                    props.dataOne?.type == 2 ? (
                        <>
                            <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                                <label className="text-g fw-bold">مدارک <sup style={{ color: 'red' }}>*</sup></label>
                            </Col>
                            <Col xs={12} className="mt-4">

                                <Form.Group controlId="formFilejhjh" className="mb-4">
                                    <Form.Label>اساسنامه شرکت (فرمت pdf) <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                    <Form.Control disabled={uploadLoading} onChange={(e) => UploadDoc('statute', e)} type="file" size="sm" accept=".pdf" />
                                </Form.Group>
                                {
                                    data.statute &&
                                    <a target="_blank" className="mb-2" href={url + data.statute} download>نمایش فایل</a>
                                }

                                <Form.Group controlId="formFilejhjjkhh" className="mb-4">
                                    <Form.Label>آگهی تاسیس (فرمت pdf) <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                    <Form.Control disabled={uploadLoading} onChange={(e) => UploadDoc('founded', e)} type="file" size="sm" accept=".pdf" />
                                </Form.Group>
                                {
                                    data.founded &&
                                    <a target="_blank" className="mb-2" href={url + data.founded} download>نمایش فایل</a>
                                }

                                <Form.Group controlId="forijijmFilejhjjkhh" className="mb-4">
                                    <Form.Label>گواهی کداقتصادی (فرمت pdf) <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                    <Form.Control disabled={uploadLoading} onChange={(e) => UploadDoc('economicCodeCertificate', e)} type="file" size="sm" accept=".pdf" />
                                </Form.Group>
                                {
                                    data.economicCodeCertificate &&
                                    <a target="_blank" className="mb-2" href={url + data.economicCodeCertificate} download>نمایش فایل</a>
                                }

                                <Form.Group controlId="formFilijijejhjjkhh" className="mb-4">
                                    <Form.Label>گواهی شناسه ملی (فرمت pdf) <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                    <Form.Control disabled={uploadLoading} onChange={(e) => UploadDoc('nationalIDCertificate', e)} type="file" size="sm" accept=".pdf" />
                                </Form.Group>
                                {
                                    data.nationalIDCertificate &&
                                    <a target="_blank" className="mb-2" href={url + data.nationalIDCertificate} download>نمایش فایل</a>
                                }

                                <Form.Group controlId="formFilijijehhhjhjjkhh" className="mb-4">
                                    <Form.Label>گواهی ارزش افزوده (فرمت pdf) <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                    <Form.Control disabled={uploadLoading} onChange={(e) => UploadDoc('certificateOfAddedValue', e)} type="file" size="sm" accept=".pdf" />
                                </Form.Group>
                                {
                                    data.certificateOfAddedValue &&
                                    <a target="_blank" className="mb-2" href={url + data.certificateOfAddedValue} download>نمایش فایل</a>
                                }

                                <Form.Group controlId="formgFilijijehhhjhjjkhh" className="mb-4">
                                    <Form.Label>آگهی تغییرات</Form.Label>
                                    <Form.Control disabled={uploadLoading} onChange={(e) => UploadDoc('certificateOfChange', e)} type="file" size="sm" accept=".pdf" />
                                </Form.Group>
                                {
                                    data.certificateOfChange &&
                                    <a target="_blank" className="mb-2" href={url + data.certificateOfChange} download>نمایش فایل</a>
                                }

                            </Col>
                        </>

                    )
                        :
                        (
                            <>
                                <Col xs={12} className="mt-4">
                                    <Form.Group controlId="formFile2" className="mb-4">
                                        <Form.Label>کارت ملی (فرمت jpg) <sup style={{ color: 'red', fontSize: 13 }}>*</sup></Form.Label>
                                        <Form.Control isInvalid={submit && nationalCard == ''} disabled={startTwo} onChange={(e) => UploadNationalCard(e)} type="file" size="sm" accept=".jpg" />
                                    </Form.Group>
                                    {
                                        nationalCard &&
                                        <a target="_blank" className="mb-2" href={url + nationalCard} download>نمایش فایل</a>
                                    }
                                    <hr />
                                </Col>
                                <Col xs={12} className="mt-4">
                                    <Form.Group controlId="formFile3" className="mb-4">
                                        <Form.Label>جواز کسب (فرمت jpg) <sup style={{ color: 'red', fontSize: 13 }}>*</sup></Form.Label>
                                        <Form.Control isInvalid={submit && license == ''} disabled={startThree} onChange={(e) => UploadLicense(e)} type="file" size="sm" accept=".jpg" />
                                    </Form.Group>
                                    {
                                        license &&
                                        <a target="_blank" className="mb-2" href={url + license} download>نمایش فایل</a>
                                    }
                                    <Row>
                                        <Col xs={12} >
                                            تاریخ مربوط به جواز کسب
                                        </Col>
                                        <Col xs={12} lg={4}>
                                            <Form.Check
                                                type={'checkbox'}
                                                id={`default-jdoijef`}
                                                checked={datesLicense.unlimitedDateBusinessLicense}
                                                onClick={(e) => setDatesLicense(prevState => ({ ...prevState, unlimitedDateBusinessLicense: e.target.checked }))}
                                                label={`نامحدود`}
                                            />
                                        </Col>
                                        {
                                            !datesLicense.unlimitedDateBusinessLicense &&
                                            <>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <label style={{ marginLeft: 7 }}>تاریخ صدور مجوز</label>
                                                        <DatePicker defaultValue={datesLicense.startDateBusinessLicense ? datesLicense.startDateBusinessLicense : undefined} locale={'fa'} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('startDateBusinessLicense', e.value)} />
                                                    </div>
                                                </Col>
                                                <Col xs={12} lg={4}>
                                                    <div>
                                                        <label style={{ marginLeft: 7 }}>تاریخ پایان مجوز</label>
                                                        <DatePicker defaultValue={datesLicense.endDateBusinessLicense ? datesLicense.endDateBusinessLicense : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('endDateBusinessLicense', e.value)} />
                                                    </div>
                                                </Col>
                                            </>
                                        }
                                    </Row>

                                    <hr />
                                </Col>
                                <Col xs={12} className="mt-4">
                                    <Form.Group controlId="formFile3" className="mb-4">
                                        <Form.Label>گواهی کد اقتصادی (فرمت pdf)</Form.Label>
                                        <Form.Control disabled={startFour} onChange={(e) => UploadEconomyCode(e)} type="file" size="sm" accept=".pdf" />
                                    </Form.Group>
                                    {
                                        economyCode &&
                                        <a target="_blank" className="mb-2" href={url + economyCode} download>نمایش فایل</a>
                                    }
                                    {
                                        <Row className="mt-2">
                                            <Col xs={12} >
                                                تاریخ مربوط به گواهی اقتصادی
                                            </Col>
                                            <Col xs={12} lg={4}>
                                                <Form.Check
                                                    type={'checkbox'}
                                                    id={`default-jdoijtef`}
                                                    checked={datesLicense.unlimitedDateEconomyCode}
                                                    onClick={(e) => setDatesLicense(prevState => ({ ...prevState, unlimitedDateEconomyCode: e.target.checked }))}
                                                    label={`نامحدود`}
                                                />
                                            </Col>
                                            {
                                                !datesLicense.unlimitedDateEconomyCode &&
                                                <>
                                                    <Col xs={12} lg={4}>
                                                        <div>
                                                            <label style={{ marginLeft: 7 }}>تاریخ صدور گواهینامه</label>
                                                            <DatePicker defaultValue={datesLicense.startDateEconomyCode ? datesLicense.startDateEconomyCode : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('startDateEconomyCode', e.value)} />
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} lg={4}>
                                                        <div>
                                                            <label style={{ marginLeft: 7 }}>تاریخ پایان گواهینامه</label>
                                                            <DatePicker defaultValue={datesLicense.endDateEconomyCode ? datesLicense.endDateEconomyCode : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('endDateEconomyCode', e.value)} />
                                                        </div>
                                                    </Col>
                                                </>
                                            }
                                        </Row>
                                    }
                                    <hr />
                                </Col>
                            </>

                        )
                }
                <Col xs={12} className="mt-4">
                    <Form.Check
                        type="switch"
                        id="q1"
                        label="آیا دارای گواهینامه‌های مدیریت كیفیت می باشید؟(فرمت pdf)"
                        checked={qOne}
                        onChange={(e) => { setQOne(e.target.checked); }}
                    />
                    <>
                        {
                            qOne &&
                            <Form.Group controlId="formFile4" className="my-3">
                                <Form.Control isInvalid={submit && qOne && aOne == ''} disabled={startQOne} onChange={(e) => UploadAOne(e)} type="file" size="sm" accept=".pdf" />
                            </Form.Group>
                        }
                        {
                            qOne && aOne &&
                            <a target="_blank" className="mb-2" href={url + aOne} download>نمایش فایل</a>
                        }
                    </>
                    {
                        qOne && <Row className="mt-2">
                            <Col xs={12} >
                                تاریخ مربوط به گواهینامه
                            </Col>
                            <Col xs={12} lg={4}>
                                <Form.Check
                                    type={'checkbox'}
                                    id={`default-jdoiffjef`}
                                    checked={datesLicense.unlimitedDateQualityManagementCertificate}
                                    onClick={(e) => setDatesLicense(prevState => ({ ...prevState, unlimitedDateQualityManagementCertificate: e.target.checked }))}
                                    label={`نامحدود`}
                                />
                            </Col>
                            {
                                !datesLicense.unlimitedDateQualityManagementCertificate &&
                                <>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ صدور گواهینامه</label>
                                            <DatePicker defaultValue={datesLicense.startDateQualityManagementCertificate ? datesLicense.startDateQualityManagementCertificate : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('startDateQualityManagementCertificate', e.value)} />
                                        </div>
                                    </Col>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ پایان گواهینامه</label>
                                            <DatePicker defaultValue={datesLicense.endDateQualityManagementCertificate ? datesLicense.endDateQualityManagementCertificate : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('endDateQualityManagementCertificate', e.value)} />
                                        </div>
                                    </Col>
                                </>
                            }
                        </Row>
                    }
                    <hr />
                </Col>
                <Col xs={12} className="mt-4">
                    <Form.Check
                        type="switch"
                        id="q2"
                        label="آیا دارای گواهینامه‌های HSE می باشید؟(فرمت pdf)"
                        checked={qTwo}
                        onChange={(e) => { setQTwo(e.target.checked); }}
                    />
                    <>
                        {
                            qTwo &&
                            <Form.Group controlId="formFile4" className="my-3">
                                <Form.Control isInvalid={submit && qTwo && aTwo == ''} disabled={startQTwo} onChange={(e) => UploadATwo(e)} type="file" size="sm" accept=".pdf" />
                            </Form.Group>
                        }
                        {
                            qTwo && aTwo &&
                            <a target="_blank" className="mb-2" href={url + aTwo} download>نمایش فایل</a>
                        }
                    </>
                    {
                        qTwo && <Row className="mt-2">
                            <Col xs={12} >
                                تاریخ مربوط به گواهینامه
                            </Col>
                            <Col xs={12} lg={4}>
                                <Form.Check
                                    type={'checkbox'}
                                    id={`default-jdytfyoijef`}
                                    checked={datesLicense.unlimitedDateHse}
                                    onClick={(e) => setDatesLicense(prevState => ({ ...prevState, unlimitedDateHse: e.target.checked }))}
                                    label={`نامحدود`}
                                />
                            </Col>
                            {
                                !datesLicense.unlimitedDateHse &&
                                <>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ صدور گواهینامه</label>
                                            <DatePicker defaultValue={datesLicense.startDateHse ? datesLicense.startDateHse : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('startDateHse', e.value)} />
                                        </div>
                                    </Col>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ پایان گواهینامه</label>
                                            <DatePicker defaultValue={datesLicense.endDateHse ? datesLicense.endDateHse : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('endDateHse', e.value)} />
                                        </div>
                                    </Col>
                                </>
                            }
                        </Row>
                    }

                    <hr />
                </Col>
                <Col xs={12} className="mt-4">
                    <Form.Check
                        type="switch"
                        id="q3"
                        label="آیا دارای گواهینامه‌های محیط زیست می باشید؟(فرمت pdf)"
                        checked={qThree}
                        onChange={(e) => { setQThree(e.target.checked); }}
                    />

                    <>
                        {
                            qThree &&
                            <Form.Group controlId="formFile4" className="my-3">
                                <Form.Control isInvalid={submit && qThree && aThree == ''} disabled={startQThree} onChange={(e) => UploadAThree(e)} type="file" size="sm" accept=".pdf" />
                            </Form.Group>
                        }
                        {
                            qThree && aThree &&
                            <a target="_blank" className="mb-2" href={url + aThree} download>نمایش فایل</a>
                        }
                    </>
                    {
                        qThree && <Row className="mt-2">
                            <Col xs={12} >
                                تاریخ مربوط به گواهینامه
                            </Col>
                            <Col xs={12} lg={4}>
                                <Form.Check
                                    type={'checkbox'}
                                    id={`default-jdosesesijef`}
                                    checked={datesLicense.unlimitedEnvironmentCertificate}
                                    onClick={(e) => setDatesLicense(prevState => ({ ...prevState, unlimitedEnvironmentCertificate: e.target.checked }))}
                                    label={`نامحدود`}
                                />
                            </Col>
                            {
                                !datesLicense.unlimitedEnvironmentCertificate &&
                                <>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ صدور گواهینامه</label>
                                            <DatePicker defaultValue={datesLicense.startEnvironmentCertificate ? datesLicense.startEnvironmentCertificate : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('startEnvironmentCertificate', e.value)} />
                                        </div>
                                    </Col>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ پایان گواهینامه</label>
                                            <DatePicker defaultValue={datesLicense.endEnvironmentCertificate ? datesLicense.endEnvironmentCertificate : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('endEnvironmentCertificate', e.value)} />
                                        </div>
                                    </Col>
                                </>
                            }
                        </Row>
                    }
                    <hr />
                </Col>
                <Col xs={12} className="mt-4">
                    <Form.Check
                        type="switch"
                        id="q4"
                        label="آیا دارای گواهینامه‌های انرژی می باشید؟(فرمت pdf)"
                        checked={qFour}
                        onChange={(e) => { setQFour(e.target.checked); }}
                    />
                    <>
                        {
                            qFour &&
                            <Form.Group controlId="formFile4" className="my-3">
                                <Form.Control isInvalid={submit && qFour && aFour == ''} disabled={startQFour} onChange={(e) => UploadAFour(e)} type="file" size="sm" accept=".pdf" />
                            </Form.Group>
                        }
                        {
                            qFour && aFour &&
                            <a target="_blank" className="mb-2" href={url + aFour} download>نمایش فایل</a>
                        }
                    </>

                    {
                        qFour && <Row className="mt-2">
                            <Col xs={12}>
                                تاریخ مربوط به گواهینامه
                            </Col>
                            <Col xs={12} lg={4}>
                                <Form.Check
                                    type={'checkbox'}
                                    id={`defaulwawat-jdoijef`}
                                    checked={datesLicense.unlimitedDateEnergyCertificate}
                                    onClick={(e) => setDatesLicense(prevState => ({ ...prevState, unlimitedDateEnergyCertificate: e.target.checked }))}
                                    label={`نامحدود`}
                                />
                            </Col>
                            {
                                !datesLicense.unlimitedDateEnergyCertificate &&
                                <>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ صدور گواهینامه</label>
                                            <DatePicker defaultValue={datesLicense.startDateEnergyCertificate ? datesLicense.startDateEnergyCertificate : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('startDateEnergyCertificate', e.value)} />
                                        </div>
                                    </Col>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ پایان گواهینامه</label>
                                            <DatePicker defaultValue={datesLicense.endDateEnergyCertificate ? datesLicense.endDateEnergyCertificate : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('endDateEnergyCertificate', e.value)} />
                                        </div>
                                    </Col>
                                </>
                            }
                        </Row>
                    }
                    <hr />
                </Col>
                <Col xs={12} className="mt-4">
                    <Form.Check
                        type="switch"
                        id="q5"
                        label="آیا محصول بر اساس استاندارد خاصی ارایه می گردد؟(فرمت pdf)	"
                        checked={qFive}
                        onChange={(e) => { setQFive(e.target.checked); }}
                    />
                    <>
                        {
                            qFive &&
                            <Form.Group controlId="formFile4" className="my-3">
                                <Form.Control isInvalid={submit && qFive && aFive == ''} disabled={startQFive} onChange={(e) => UploadAFive(e)} type="file" size="sm" accept=".pdf" />
                            </Form.Group>
                        }
                        {
                            qFive && aFive &&
                            <a target="_blank" className="mb-2" href={url + aFive} download>نمایش فایل</a>
                        }
                    </>
                    {
                        qFive && <Row className="mt-2">

                            <Col xs={12}>
                                تاریخ مربوط به استاندارد
                            </Col>
                            <Col xs={12} lg={4}>
                                <Form.Check
                                    type={'checkbox'}
                                    id={`default-8tfjdoijef`}
                                    checked={datesLicense.unlimitedDateProductStandard}
                                    onClick={(e) => setDatesLicense(prevState => ({ ...prevState, unlimitedDateProductStandard: e.target.checked }))}
                                    label={`نامحدود`}
                                />
                            </Col>
                            {
                                !datesLicense.unlimitedDateProductStandard &&
                                <>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ صدور استاندارد</label>
                                            <DatePicker defaultValue={datesLicense.startDateProductStandard ? datesLicense.startDateProductStandard : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('startDateProductStandard', e.value)} />
                                        </div>
                                    </Col>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ پایان استاندارد</label>
                                            <DatePicker defaultValue={datesLicense.endDateProductStandard ? datesLicense.endDateProductStandard : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('endDateProductStandard', e.value)} />
                                        </div>
                                    </Col>
                                </>
                            }
                        </Row>
                    }
                    <hr />
                </Col>
                <Col xs={12} className="mt-4">
                    <Form.Check
                        type="switch"
                        id="q6"
                        label="آیا محصول دارای كد استاندارد ایران (ایران‌كد) می باشد؟(فرمت pdf)"
                        checked={qSix}
                        onChange={(e) => { setQSix(e.target.checked); }}
                    />
                    <>
                        {
                            qSix &&
                            <Form.Group controlId="formFile4" className="my-3">
                                <Form.Control isInvalid={submit && qSix && aSix == ''} disabled={startQSix} onChange={(e) => UploadASix(e)} type="file" size="sm" accept=".pdf" />
                            </Form.Group>
                        }
                        {
                            qSix && aSix &&
                            <a target="_blank" className="mb-2" href={url + aSix} download>نمایش فایل</a>
                        }
                    </>
                    {
                        qSix && <Row className="mt-2">
                            <Col xs={12}>
                                تاریخ مربوط به استاندارد
                            </Col>
                            <Col xs={12} lg={4}>
                                <Form.Check
                                    type={'checkbox'}
                                    id={`defeeault-jdxxoijef`}
                                    checked={datesLicense.unlimitedIranCode}
                                    onClick={(e) => setDatesLicense(prevState => ({ ...prevState, unlimitedIranCode: e.target.checked }))}
                                    label={`نامحدود`}
                                />
                            </Col>
                            {
                                !datesLicense.unlimitedIranCode &&
                                <>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ صدور گواهینامه</label>
                                            <DatePicker defaultValue={datesLicense.startDateIranCode ? datesLicense.startDateIranCode : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('startDateIranCode', e.value)} />
                                        </div>
                                    </Col>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ پایان گواهینامه</label>
                                            <DatePicker defaultValue={datesLicense.endDateIranCode ? datesLicense.endDateIranCode : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('endDateIranCode', e.value)} />
                                        </div>
                                    </Col>
                                </>
                            }
                        </Row>
                    }
                    <hr />
                </Col>
                <Col xs={12} className="mt-4">
                    <Form.Check
                        type="switch"
                        id="q7"
                        label="آیا محصول دارای ضمانتنامه كیفیت (گارانتی) می باشد ؟(فرمت pdf)"
                        checked={qSeven}
                        onChange={(e) => { setQSeven(e.target.checked); }}
                    />
                    <>
                        {
                            qSeven &&
                            <Form.Group controlId="formFile4" className="my-3">
                                <Form.Control isInvalid={submit && qSeven && aSeven == ''} disabled={startQSeven} onChange={(e) => UploadASeven(e)} type="file" size="sm" accept=".pdf" />
                            </Form.Group>
                        }
                        {
                            qSeven && aSeven &&
                            <a target="_blank" className="mb-2" href={url + aSeven} download>نمایش فایل</a>
                        }
                    </>
                    {
                        qSeven && <Row className="mt-2">
                            <Col xs={12}>
                                تاریخ مربوط به ضمانتنامه
                            </Col>
                            <Col xs={12} lg={4}>
                                <Form.Check
                                    type={'checkbox'}
                                    id={`defaxerult-jdoijxeef`}
                                    checked={datesLicense.unlimitedDateGarranty}
                                    onClick={(e) => setDatesLicense(prevState => ({ ...prevState, unlimitedDateGarranty: e.target.checked }))}
                                    label={`نامحدود`}
                                />
                            </Col>
                            {
                                !datesLicense.unlimitedDateGarranty &&
                                <>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ صدور گارانتی</label>
                                            <DatePicker defaultValue={datesLicense.startDateGarranty ? datesLicense.startDateGarranty : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('startDateGarranty', e.value)} />
                                        </div>
                                    </Col>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ پایان گارانتی</label>
                                            <DatePicker defaultValue={datesLicense.endDateGarranty ? datesLicense.endDateGarranty : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('endDateGarranty', e.value)} />
                                        </div>
                                    </Col>
                                </>
                            }
                        </Row>
                    }
                    <hr />
                </Col>
                <Col xs={12} className="mt-4">
                    <Form.Check
                        type="switch"
                        id="q8"
                        label="آیا خدمات‌پس‌ازفروش (وارنتی) دارید؟(فرمت pdf)"
                        checked={qEight}
                        onChange={(e) => { setQEight(e.target.checked); }}
                    />
                    <>
                        {
                            qEight &&
                            <Form.Group controlId="formFile4" className="my-3">
                                <Form.Control isInvalid={submit && qEight && aEight == ''} disabled={startQEight} onChange={(e) => UploadAEight(e)} type="file" size="sm" accept=".pdf" />
                            </Form.Group>
                        }
                        {
                            qEight && aEight &&
                            <a target="_blank" className="mb-2" href={url + aEight} download>نمایش فایل</a>
                        }
                    </>
                    {
                        qEight && <Row className="mt-2">
                            <Col xs={12}>
                                تاریخ مربوط به ضمانتنامه
                            </Col>
                            <Col xs={12} lg={4}>
                                <Form.Check
                                    type={'checkbox'}
                                    id={`defau675lt-jdoidxjef`}
                                    checked={datesLicense.unlimitedDateWarranty}
                                    onClick={(e) => setDatesLicense(prevState => ({ ...prevState, unlimitedDateWarranty: e.target.checked }))}
                                    label={`نامحدود`}
                                />
                            </Col>
                            {
                                !datesLicense.unlimitedDateWarranty &&
                                <>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ صدور گارانتی</label>
                                            <DatePicker defaultValue={datesLicense.startDateWarranty ? datesLicense.startDateWarranty : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('startDateWarranty', e.value)} />
                                        </div>
                                    </Col>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ پایان گارانتی</label>
                                            <DatePicker defaultValue={datesLicense.endDateWarranty ? datesLicense.endDateWarranty : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('endDateWarranty', e.value)} />
                                        </div>
                                    </Col>
                                </>
                            }
                        </Row>
                    }
                    <hr />
                </Col>
                <Col xs={12} className="mt-4">
                    <Form.Check
                        type="switch"
                        id="q9"
                        label="آیا در وندر لیست نفت، گاز یا پتروشیمی ثبت هستید؟(فرمت pdf)"
                        checked={qNine}
                        onChange={(e) => { setQNine(e.target.checked); }}
                    />
                    <>
                        {
                            qNine &&
                            <Form.Group controlId="formFile4" className="my-3">
                                <Form.Control isInvalid={submit && qNine && aNine == ''} disabled={startQNine} onChange={(e) => UploadANine(e)} type="file" size="sm" accept=".pdf" />
                            </Form.Group>
                        }
                        {
                            qNine && aNine &&
                            <a target="_blank" className="mb-2" href={url + aNine} download>نمایش فایل</a>
                        }
                    </>
                    {
                        qNine && <Row className="mt-2">
                            <Col xs={12}>
                                تاریخ مربوط به گواهینامه
                            </Col>

                            <Col xs={12} lg={4}>
                                <Form.Check
                                    type={'checkbox'}
                                    id={`defaulttf-jdoitftfjef`}
                                    checked={datesLicense.unlimitedDateVendorList}
                                    onClick={(e) => setDatesLicense(prevState => ({ ...prevState, unlimitedDateVendorList: e.target.checked }))}
                                    label={`نامحدود`}
                                />
                            </Col>
                            {
                                !datesLicense.unlimitedDateVendorList &&
                                <>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ صدور گواهینامه</label>
                                            <DatePicker defaultValue={datesLicense.startDateVendorList ? datesLicense.startDateVendorList : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('startDateVendorList', e.value)} />
                                        </div>
                                    </Col>
                                    <Col xs={12} lg={4}>
                                        <div>
                                            <label style={{ marginLeft: 7 }}>تاریخ پایان گواهینامه</label>
                                            <DatePicker defaultValue={datesLicense.endDateVendorList ? datesLicense.endDateVendorList : undefined} inputClass="datepicker" direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate('endDateVendorList', e.value)} />
                                        </div>
                                    </Col>
                                </>
                            }
                        </Row>
                    }
                    <hr />
                </Col>
                <Col xs={12} className="mt-4">
                    <Form.Check
                        type="switch"
                        id="q10"
                        label="آیا در فرآیند محصول تولیدی و خدمات شما، مراحل جلوگیری از اتلاف و کاهش انرژی منظور گردیده است؟(در صورت مثبت بودن خلاصه ای از اقدامات انجام شده در قالب فایل pdf ضمیمه گردد)"
                        checked={qTen}
                        onChange={(e) => { setQTen(e.target.checked); }}
                    />
                    <>
                        {
                            qTen &&
                            <Form.Group controlId="formFile4" className="my-3">
                                <Form.Control isInvalid={submit && qTen && aTen == ''} disabled={startQTen} onChange={(e) => UploadATen(e)} type="file" size="sm" accept=".pdf" />
                            </Form.Group>
                        }
                        {
                            qTen && aTen &&
                            <a target="_blank" className="mb-2" href={url + aTen} download>نمایش فایل</a>
                        }
                    </>

                    <hr />
                </Col>
                <Col xs={12} className="mt-4 text-center" >
                    <div className="d-grid gap-2">
                        <Button variant="success" onClick={() => changeStep()}>
                            مرحله بعد
                        </Button>
                        <Button variant="muted" className="mt-2" onClick={() => changeStepBack()}>
                            مرحله قبل
                        </Button>
                    </div>
                </Col>
            </Row>
        </Container >
    )
}